import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-blog",
    templateUrl: "./blog.component.html",
    styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
    newsList: any = [];

    constructor() {}

    ngOnInit() {
        this.newsList = [
            {
                title: "2025碩達世界地球日Week3",
                date: "May 7, 2025",
                image: "assets/img/blog/blog_details/2025EarthDay/week3.jpg",
                description:
                    "2025碩達世界地球日第三週！請大家跟我們一起繼續努力！!......",
                link: "/news-details?info=bd9",
            },
            {
                title: "從衝突中前行－倫敦「超低排放區」的轉型爭議與制度韌性",
                date: "May 6, 2025",
                image: "assets/img/blog/倫敦空汙治理/eDM banner top.jpg",
                description:
                    "環境政策不是口號，而是可以真實改變一整個城市生活品質的工程",
                link: "/news-details?info=bd8",
            },
            {
                title: "2025碩達世界地球日Week2",
                date: "April 30, 2025",
                image: "assets/img/blog/blog_details/2025EarthDay/week2.jpg",
                description:
                    "2025碩達世界地球日第二週！請大家跟我們一起繼續努力！!......",
                link: "/news-details?info=bd7",
            },
            {
                title: "2025碩達世界地球日Week1",
                date: "April 22, 2025",
                image: "assets/img/blog/2025碩達世界地球日_1.png",
                description:
                    "世界地球日今天啟動啦！大家準備好，和我們一起**「陪地球練笑肌」**了嗎？......",
                link: "/news-details?info=bd6",
            },
            {
                title: "面對下一場震盪，誰先準備好未來？<br />碩達捐贈臺科大N-Cour永續淨零平台，攜手打造數位永續共好起點",
                date: "April 15, 2025",
                image: "assets/img/blog/N-Cour/NTUST/NCour_NTUST_2.jpg",
                description:
                    "從川普新關稅陰影到台灣限空令衝擊，企業如何不再只是應付？答案藏在這場關鍵的校園起步......",
                link: "/news-details?info=bd5",
            },
            {
                title: "N-Cour永續淨零平台成果發表會暨捐贈儀式",
                date: "March 24, 2025",
                image: "assets/img/blog/N-Cour/Edm_02.jpg",
                description:
                    "尊敬的企業先進：各國陸續調整碳政策、美國與歐洲進入新一輪ESG佈局，台灣也加速推動最新《氣候變遷因應法》、《碳費機制》規範......",
                link: "/news-details?info=bd4",
            },
            {
                title: "我們宣布，碩達系統加入「我響應，為淡水河做一件事！」",
                date: "June 17, 2024",
                image: "assets/img/blog/淡水河公約社群發送版_20240617_v1.png",
                description:
                    "聯合國世界水發展報告顯示 ● COVID-2019，加劇數10億人民對清潔飲用水的緊迫需求。 ● 2050年，全球有10億城市人口將缺水。......",
                link: "/news-details?info=bd3",
            },
            {
                title: "2024碩達世界地球日",
                date: "June 17, 2024",
                image: "assets/img/blog/碩達世界地球日.jpg",
                description:
                    "生活加一點綠，心情多一分甜，攜手讓我們往永續更靠近。......",
                link: "/news-details?info=bd2",
            },
            {
                title: "科學少女: 與孩子共解人生課題- 台灣首部青少年科普電影",
                date: "Octorber 04, 2022",
                image: "assets/img/blog/20221003003987.jpg",
                description:
                    "九月上檔的科普電影科學少女，內容主要是述說華人世界中普遍存在已久的兩個問題: 一. 對生死議題的忌諱、二. 對於性別與能力的偏見......",
                link: "/news-details?info=bd1",
            },
            {
                title: "企業防疫營運不中斷戰術大公開",
                date: "June 14, 2021",
                image: "assets/img/main/首頁廣告1800x900a.jpg",
                description:
                    "疫情持續燃燒，企業營運不能停，遠距安心不怠工，三級警戒急又快，企業資訊沒有超前部屬怎辦!?遠距+分流又該怎麼做!?......",
                link: "/solution-details?info=so4",
            },
        ];
    }
}
